// eslint-disable-next-line
export const COLLECTION_USERS = 'users';
// eslint-disable-next-line
export const COLLECTION_POSTS = 'posts';
// eslint-disable-next-line
export const COLLECTION_ORGANIZATIONS = 'organizations';
// eslint-disable-next-line
export const COLLECTION_ROLES = 'roles';
// eslint-disable-next-line
export const COLLECTION_CAMPAIGNADDS = 'campaignAdds';
// eslint-disable-next-line
export const COLLECTION_NOTIFICATIONS = 'notifications';
